import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import axios from "axios"

export default new Vuex.Store({
  state: () => ({
    homePhotos: null,
    portfolio: null,
    privatePortfolio: null,
    pageReady: false,
    pageName: null,
  }),
  getters: {
    defaultPortfolioCategory: state => {
      if (state.portfolio) {
        return state.portfolio[0].slug
      } else {
        return null
      }
    },
    defaultClientPortfolioCategory: state => {
      if (state.privatePortfolio) {
        return state.privatePortfolio[0].slug
      } else {
        return null
      }
    }
  },
  mutations: {
    SAVE_HOMEPHOTOS(state, {
      data
    }) {
      state.homePhotos = data
    },
    SAVE_PORTFOLIO(state, {
      data
    }) {
      state.portfolio = data
    },
    SAVE_PRIVATE_PORTFOLIO(state, {
      data
    }) {
      state.privatePortfolio = data
    },
    TOGGLE_PAGE_READY(state, isReady) {
      if (isReady !== undefined) {
        state.pageReady = isReady
      } else {
        state.pageReady = !state.pageReady
      }
    },
    CHANGE_GALLERY_NAME(state, name) {
      if (name) {
        state.pageName = name
      }
    }
  },
  actions: {
    getHomePhotos(context) {
      if (!context.state.homePhotos) {
        return axios.get(`/en/api/home/`)
          .then(function (response) {
            context.commit('SAVE_HOMEPHOTOS', {
              'data': response.data
            })
            return response.data
          })
          .catch(function (error) {
            return error
          })
      } else {
        return context.state.portfolio
      }
    },
    getPortfolio(context) {
      if (!context.state.portfolio) {
        return axios.get(`/en/api/portfolio/`)
          .then(function (response) {
            context.commit('SAVE_PORTFOLIO', {
              'data': response.data
            })
            return response.data
          })
          .catch(function (error) {
            return error
          })
      } else {
        return context.state.portfolio
      }
    },
    getPrivatePortfolio(context) {
      if (!context.state.privatePortfolio) {
        return axios.get(`/en/api/private/portfolio/`)
          .then(function (response) {
            context.commit('SAVE_PRIVATE_PORTFOLIO', {
              'data': response.data
            })
            return response.data
          })
          .catch(function (error) {
            return error
          })
      } else {
        return context.state.privatePortfolio
      }
    },
    togglePageReady(context, isReady) {
      context.commit('TOGGLE_PAGE_READY', isReady)
    },
    changepageName(context, name) {
      context.commit('CHANGE_GALLERY_NAME', name)
    }
  }
})